<template>
  <div>
    
    <b-row class="mb-2">
      <b-col>
        <div class="d-flex align-items-center">
          <b-button-group>
            <b-button
              :disabled="userPermissions < 3"
              variant="gradient-primary"
              @click="criarModelo"
            >
              Criar Modelo
            </b-button>
          </b-button-group>
          
          <b-form-checkbox
            switch
            v-model="mostrar_mensagens_avulsa"
            class="ml-2"
          >
            Mostrar mensagens avulsas
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  
    
    <b-alert :variant="getErrors.color" v-if="getErrors.hasMessage" show="">
      <div class="alert-body text-bold">{{ getErrors.message }}</div>
      <div
        class="alert-body"
        v-for="(error, index) in getErrors.messageArray"
        :key="index"
      >
        {{ error[0] }}
      </div>
    </b-alert>
    
    <b-table
      striped
      hover
      small
      responsive
      :items="modelosComputados"
      :fields="fields"
      
    >
      
      <template #cell(plano)="data">
          {{ nomePlano(data.item.plano) }}
      </template>
      
      <template #cell(sistema)="data">
        <b-badge :variant="data.item.sistema ? 'light-success' : 'light-danger'">
          {{ data.item.sistema ? 'Sim' : 'Não' }}
        </b-badge>
      </template>
      
      <template #cell(whatsapp)="data">
        <b-badge :variant="data.item.whatsapp ? 'light-success' : 'light-danger'">
          {{ data.item.whatsapp ? 'Sim' : 'Não' }}
        </b-badge>
      </template>
      
      <template #cell(email)="data">
        <b-badge :variant="data.item.email ? 'light-success' : 'light-danger'">
          {{ data.item.email ? 'Sim' : 'Não' }}
        </b-badge>
      </template>
      
      <template #cell(ativo)="data">
        <b-badge :variant="data.item.ativo ? 'light-success' : 'light-danger'">
          {{ data.item.ativo ? 'Sim' : 'Não' }}
        </b-badge>
      </template>
      
<!--      DETALHES-->
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col
              md="6"
              class="mb-1"
            >
              <strong>Data Criação : </strong>{{ row.item.created_at | converteDataHora}}
            </b-col>
            <b-col
              md="6"
              class="mb-1"
            >
              <strong>Data Última Alteração : </strong>{{ row.item.updated_at | converteDataHora }}
            </b-col>
            <b-col
              md="6"
              class="mb-1"
            >
              <strong>Título : </strong>{{ row.item.titulo }}
            </b-col>
            <b-col
              md="6"
              class="mb-1"
            >
              <strong>Link : </strong>{{ row.item.link }}
            </b-col>
           
            <b-col
              class="mb-1"
            >
              <strong>Conteúdo da Mensagem : </strong>{{ row.item.conteudo }}
            </b-col>
          
          </b-row>
          
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            Fechar Detalhes
          </b-button>
        </b-card>
        
      </template>
      
<!--      OPÇÕES-->
      <template #cell(opções)="data">
        
        <b-button
          class="btn-icon"
          variant="flat-secondary"
          size="sm"
          @click="data.toggleDetails"
        >
          <feather-icon icon="EyeIcon" />
        </b-button>
        
        <b-button
          class="btn-icon"
          variant="flat-secondary"
          size="sm"
          @click="editarModelo(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        
        <b-button
          class="btn-icon"
          variant="flat-danger"
          size="sm"
          @click="removerModelo(data.item.id)"
        >
          <feather-icon icon="Trash2Icon" />
        
        </b-button>
      
      </template>
      
    </b-table>
    
    <ModalCriarModelos />
    <ModalEditarModelos :form="formEditar " />
  </div>
</template>

<script>
import {BAlert, BBadge, BButton, BCard, BCol, BRow, BTable, BFormCheckbox, BButtonGroup} from "bootstrap-vue";
import {mapGetters, mapState} from "vuex";
import formataData from "@/mixins/formataData";
import ModalCriarModelos from "@/views/mensagens/modelos/ModalCriarModelos.vue";
import planos from "@/views/mensagens/modelos/planos";
import ModalEditarModelos from "@/views/mensagens/modelos/ModalEditarModelos.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: 'ModeloMensagemPrincipal',
  mixins: [formataData, planos],
  components: {
    BButtonGroup,
    BAlert,
    ModalEditarModelos,
    ModalCriarModelos,
    BCol,
    BRow,
    BCard,
    BBadge,
    BTable,
    BButton,
    BFormCheckbox
  },
  data() {
    return {
      getErrors: {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      },
      mostrar_mensagens_avulsa: false,
      formEditar: [],
      fields: [
        { key: "id", label: "ID", thStyle: { width: "5%" } },
        { key: "nome", label: "Nome", sortable: true },
        { key: "tipo_gatilho", label: "Tipo Gatilho" },
        { key: "dias_offset", label: "Dias Offset" },
        { key: "plano", label: "Plano" },
        { key: "sistema", label: "Sistema" },
        { key: "whatsapp", label: "WhatsApp" },
        { key: "email", label: "Email" },
        { key: "ativo", label: "ativo" },
        { key: "opções", label: "Opções" },
      ]
    }
  },
  
  mounted() {
    this.$store.dispatch('modeloMensagens/listaModelos')
  },
  
  computed: {
    ...mapState({
      modelos: state => state.modeloMensagens.modelos,
    }),
    ...mapGetters({
      userPermissions: "user/userPermissions",
      ModeloAssinaturas: 'modeloMensagens/ModeloAssinaturas',
      ModeloMensagensAvulsa: 'modeloMensagens/ModeloMensagensAvulsas',
    }),
    
    modelosComputados() {
      
      if(this.mostrar_mensagens_avulsa) {
        return this.ModeloMensagensAvulsa
      }
      
      return this.ModeloAssinaturas
    }
  },
  
  methods: {
    criarModelo() {
      this.$bvModal.show('modalCriarMensagemModelo')
    },
    
    editarModelo(mensagem) {
      this.formEditar = {...mensagem}
      this.$bvModal.show('modalEditarMensagemModelo')
    },
    
    removerModelo(mensagemId) {
      
      this.$bvModal
        .msgBoxConfirm('Você tem certeza que deseja excluir este modelo?', {
          title: 'Confirmar Exclusão',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Cancelar',
          cancelVariant: 'secondary',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then(confirmed => {
          if (confirmed) {
            this.spinner = true;
            this.submit = true;
            
            this.$http
              .delete(`adm/mensagens/${mensagemId}`)
              .then((res) => {
                if (res.data) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Modelo de Mensagem Excluído com Sucesso!",
                      icon: "InfoIcon",
                      variant: "success",
                    },
                  });
                  this.$store.dispatch('modeloMensagens/listaModelos');
                }
              })
              .catch((error) => {
                this.getErrors = this.$responseMessages.getMessage(error, null);
              })
              .finally(() => {
                this.spinner = false;
                this.submit = false;
              });
          }
        })
        .catch(() => {
        
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Ação de exclusão cancelada.",
              icon: "InfoIcon",
              variant: "info",
            },
          });
        });
      
    },
    
    nomePlano(plano) {
      return this.planos.find(item => item.value === plano).text
    }
    
  }
}
</script>